// API configuration utility

const getApiBaseUrl = () => {
    // Check if we have environment variable
    if (process.env.REACT_APP_API_BASE_URL) {
        return process.env.REACT_APP_API_BASE_URL;
    }

    // Fallback based on current domain
    const currentHost = window.location.hostname;

    if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
        // Local development - use dev worker
        return 'https://therapp-dev.whiteraven.workers.dev';
    } else if (currentHost.includes('therapp-dev') || currentHost.includes('pages.dev')) {
        // Development deployment
        return 'https://therapp-dev.whiteraven.workers.dev';
    } else {
        // Production
        return 'https://therapp-backend.whiteraven.workers.dev';
    }
};

export const API_BASE_URL = getApiBaseUrl();

export const apiCall = async (endpoint, options = {}) => {
    const url = `${API_BASE_URL}${endpoint}`;

    const defaultOptions = {
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    };

    const response = await fetch(url, { ...defaultOptions, ...options });

    if (!response.ok) {
        throw new Error(`API call failed: ${response.status} ${response.statusText}`);
    }

    return response.json();
};

// Specific API functions
export const savePreQuestionnaire = (data) =>
    apiCall('/api/pre-questionnaire', {
        method: 'POST',
        body: JSON.stringify(data)
    });

export const savePostQuestionnaire = (data) =>
    apiCall('/api/post-questionnaire', {
        method: 'POST',
        body: JSON.stringify(data)
    });

export const saveEmailSignup = (name, email, source = 'landing_page', discount_type = '10%') =>
    apiCall('/api/email-signup', {
        method: 'POST',
        body: JSON.stringify({ name, email, source, discount_type })
    });

export const createStripeCheckout = (amount, description, email) => {
    // Get current page URL for return redirect
    const returnUrl = window.location.href.split('?')[0]; // Remove existing query params

    return apiCall('/api/create-checkout-session', {
        method: 'POST',
        body: JSON.stringify({ amount, description, email, returnUrl })
    });
};

export const verifyPayment = (sessionId) =>
    apiCall(`/api/verify-payment?session_id=${sessionId}`, {
        method: 'GET'
    });

export const getAdminStats = (apiKey) =>
    apiCall('/api/admin/stats', {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${apiKey}`
        }
    });

export const trackChatbotSession = (action, sessionData = {}, stepData = {}) => {
    // Get userId from localStorage if available
    const userId = localStorage.getItem('userId');

    return apiCall('/api/track-chatbot-session', {
        method: 'POST',
        body: JSON.stringify({
            action, // 'start', 'step', 'complete', 'abandon'
            sessionData,
            stepData,
            userId
        })
    });
};

export const trackPDFUnlockChoice = (choice, buttonText, action = 'click', additionalData = {}) => {
    // Get userId from localStorage if available
    const userId = localStorage.getItem('userId');

    return apiCall('/api/track-pdf-unlock-choice', {
        method: 'POST',
        body: JSON.stringify({
            choice, // 'questionnaire', 'payment', or 'email'
            buttonText, // exact text of the button
            action, // 'click', 'success', 'error'
            additionalData,
            userId
        })
    });
};
